import { useMutation } from '@tanstack/react-query';
import { PeopleService } from 'src/services/api';
import { useNotification } from 'src/hooks/useNotification';

export const useMutateExportPeopleList = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (query: string) => PeopleService.exportListPeople(query),
  });
  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateRecheckEmailValidation = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: ({ peopleId, emailId }: { peopleId: string; emailId: string }) =>
      PeopleService.recheckEmailValidation({ peopleId, emailId }),
  });
  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateContributePeople = () => {
  const { notification } = useNotification();
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (body: TypeDTOContributePeople) => PeopleService.contributePeopleData(body),
    onSuccess: (response: IResponse<ExpectedAny>) => {
      notification(response);
    },
  });
  return {
    isPending,
    mutateAsync,
  };
};
